import React from 'react';

const TYPE_BADGES = {
  in: { label: 'Stock In', className: 'bg-green-100 text-green-700' },
  out: { label: 'Stock Out', className: 'bg-red-100 text-red-700' },
  adjustment: { label: 'Adjustment', className: 'bg-yellow-100 text-yellow-700' },
  transfer: { label: 'Transfer', className: 'bg-blue-100 text-blue-700' },
  count: { label: 'Count', className: 'bg-purple-100 text-purple-700' },
};

const RecentMovements = ({ movements }) => {
  if (!movements || movements.length === 0) {
    return (
      <p className="text-sm text-gray-400 text-center py-6">
        No recent movements
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 border-b">
            <th className="pb-2 pr-4 font-medium">Date</th>
            <th className="pb-2 pr-4 font-medium">Product</th>
            <th className="pb-2 pr-4 font-medium">Type</th>
            <th className="pb-2 pr-4 font-medium">Qty</th>
            <th className="pb-2 font-medium">User</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {movements.map((m) => {
            const badge = TYPE_BADGES[m.type] || TYPE_BADGES.adjustment;
            return (
              <tr key={m.id} className="hover:bg-gray-50">
                <td className="py-2.5 pr-4 text-gray-600 whitespace-nowrap">
                  {new Date(m.date).toLocaleDateString()}
                </td>
                <td className="py-2.5 pr-4 font-medium text-gray-800">
                  {m.product_name || 'Unknown'}
                  {m.product_type && (
                    <span className="ml-1.5 text-xs text-gray-400 capitalize">
                      ({m.product_type})
                    </span>
                  )}
                </td>
                <td className="py-2.5 pr-4">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${badge.className}`}>
                    {badge.label}
                  </span>
                </td>
                <td className="py-2.5 pr-4 text-gray-700 font-medium">
                  {m.type === 'out' || (m.type === 'adjustment' && m.quantity < 0) ? '-' : '+'}
                  {Math.abs(m.quantity)}
                </td>
                <td className="py-2.5 text-gray-600">
                  {m.user_name}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RecentMovements;
